import React, { useEffect, useState } from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Tab from "../../components/Tabs/Tab";
import Tabs from "../../components/Tabs/Tabs";
import PublishedContent from "./components/PublishedContent/PublishedContent";
import PublicationDetails from "./components/PublicationDetails/PublicationDetails";

import "./Publication.scss";

const PublicationTabs = {
  Details: 0,
  PublishedContent: 1,
};

export default function Publication({
  taskDetails,
  setShowUpdatePublicationLinkModal,
  taskOwner,
  dateCreated,
}) {
  const publicationExists = taskDetails && taskDetails.publication;
  const [activeTab, setActiveTab] = useState(PublicationTabs.Details);

  useEffect(() => {
    if (taskDetails.publication === null) {
      setActiveTab(PublicationTabs.PublishedContent);
    }
  }, [taskDetails]);

  return (
    <div className="publication">
      <Tabs>
        {publicationExists && (
          <Tab
            tabText={
              <IDHFormattedMessage id="ws_details" defaultMessage="Details" />
            }
            active={activeTab === PublicationTabs.Details}
            onClick={() => setActiveTab(PublicationTabs.Details)}
            medium
          />
        )}
        <Tab
          tabText={
            <IDHFormattedMessage
              id="ws_published_content"
              defaultMessage="Published content"
            />
          }
          active={activeTab === PublicationTabs.PublishedContent}
          onClick={() => setActiveTab(PublicationTabs.PublishedContent)}
          medium
        />
      </Tabs>
      {activeTab === PublicationTabs.Details && taskDetails.publication && (
        <PublicationDetails
          publication={taskDetails.publication}
          metadata={taskDetails.metadata}
          setShowUpdatePublicationLinkModal={setShowUpdatePublicationLinkModal}
          taskOwner={taskOwner}
          dateCreated={dateCreated}
        />
      )}
      {activeTab === PublicationTabs.PublishedContent && (
        <PublishedContent
          taskUuid={taskDetails.taskId}
          publishedContents={taskDetails.wsPublishedContents}
        />
      )}
    </div>
  );
}
